
    var riot = require('riot')
    riot.tag2('register', '<h2>新規登録</h2> <form class="pure-form pure-form-stacked" onsubmit="{formSubmit}"> <div class="kf-form-group"> <label for="mail">メールアドレス</label> <input class="pure-input-1" id="mail" ref="mail" required type="email"> </div> <div class="kf-form-group"> <label for="password">パスワード</label> <input class="pure-input-1" type="password" id="password" ref="password" required> </div> <div class="kf-form-group"> <label for="name">名前</label> <input class="pure-input-1" type="text" id="name" ref="name" required> </div> <div class="kf-form-group"> <button class="pure-button pure-button-success kf-block">登録する</button> </div> <p class="attention"> <a href="https://smct.jp/tcs/" target="_blank">利用規約</a> をお読みの上、「登録する」ボタンを押してください。 </p> <a href="#login">ログイン画面へ戻る</a> </form>', 'register .attention,[data-is="register"] .attention{ font-size: 0.9rem; }', '', function(opts) {
    this.formSubmit = e => {
      e.preventDefault();
      this.action.register({
        name: this.refs.name.value,
        mail: this.refs.mail.value,
        password: this.refs.password.value
      });
    };
});

riot.tag2('register-sent', '<p>メールアドレスに新規登録用のメールを送信しました。</p> <a href="#login">ログイン画面へ戻る</a>', '', '', function(opts) {
});

riot.tag2('register-complete', '<p if="{opts.success}">新規登録に成功しました。</p> <p if="{opts.failed}">新規登録に失敗しました。</p> <a href="#login">ログイン画面へ戻る</a>', '', '', function(opts) {
});
    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('register')
riot.reload('register-sent')
riot.reload('register-complete')
    }
  }
  